
































































import Translation from '@/mixins/Translation'
import {Input} from 'element-ui'
import {Component, Mixins, Prop, Watch, Ref} from 'vue-property-decorator'
import {namespace} from 'vuex-class'
import PagePopup from '@/components/popup/page/PagePopup.vue'
import CompanyItem from '@/components/CompanyItem.vue'
import EmptyMessage from '@/components/EmptyMessage.vue'
import {ClientsPayload} from '@/store/modules/clients/types'

const layout = namespace('layout')
const clients = namespace('clients')
const companies = namespace('companies')

@Component({
  components: {
    EmptyMessage,
    CompanyItem,
    PagePopup,
    [Input.name]: Input,
  },
})
export default class SearchClientPopup extends Mixins(Translation) {
  @Prop({default: 'terms', type: String}) translation
  @Prop({default: null, type: Boolean}) value
  @Prop({default: '', type: String}) searchValue
  @Ref('search-input') readonly searchInput!: Input

  loading: boolean = false
  searching: boolean = false
  searchKeyword: string | null = ''
  open: boolean = false

  results = [] as any
  CLIENT_DIVIDER_NAME: string = '기존 거래처'
  COMPANY_DIVIDER_NAME: string = '검색된 거래처'
  hasDividerTitle: object = {}

  EXTERNAL_SEARCH: boolean = true
  INTERNAL_SEARCH: boolean = false

  @layout.Mutation('updateError') updateError
  @companies.Action('getCompanies') getCompanies
  @companies.State('nextPage') nextPage
  @companies.Mutation('clear') clearCompanies
  @companies.Getter('noMoreCompany') noMoreCompany
  @clients.Action('getClients') getClients: (payload?: ClientsPayload) => Promise<void>
  @clients.State('clients') clients: object[]
  @clients.Getter('noMoreClient') noMoreClient
  @clients.Mutation('clear') clear: () => void

  @Watch('value', {immediate: true})
  __value(val) {
    this.open = val
    if(val) {
      this.searchKeyword = this.searchValue
      if(this.searchKeyword) {
        this.search()
      } else {
        this.loadClients()
      }
    }
  }

  resetResult() {
    this.results = []
    this.hasDividerTitle = {}
  }

  loadClients() {
    this.loading = true
    this.getClients({sales: true})
      .catch((error) => {
        this.updateError({
          id: 'get-clients',
          message: `${this.ts('client')} 목록을 불러오는데 ${this.ts('failed')}하였습니다.`,
        })
        throw error
      })
      .finally(() => {
        this.loading = false
      })
  }

  get disabledInfiniteScroll(): boolean {
    if(this.searchKeyword) {
      return this.searching || (this.noMoreCompany && this.noMoreClient)
    }
    return this.loading || this.noMoreClient
  }

  onClose() {
    this.clearCompanies()
    this.clear()
    this.resetResult()
    this.$emit('input', false)
  }

  blurSearchInput() {
    const inputEl: any = this.searchInput
    if(inputEl) {
      inputEl.blur()
    }
  }

  listHas(data) {
    return Array.isArray(data) && data.length > 0
  }

  concatCompanyResult(data) {
    if(this.listHas(data)) {
      // 사업자번호 같으면 기존 거래처에만 표시되도록 함. TODO: 사업자번호 같고 종사업자번호 다른 Client 처리
      const filtered = data.filter((d) => !this.clients.find((c: any) => d.bizRegistrationNumber === c.bizRegistrationNumber))
      if(this.listHas(filtered)) {
        this.concatDivider(this.COMPANY_DIVIDER_NAME)
        this.concatResult(filtered, this.EXTERNAL_SEARCH)
      }
    }
  }

  concatClientResult(data) {
    if(this.listHas(data)) {
      this.concatDivider(this.CLIENT_DIVIDER_NAME)
      this.concatResult(data, this.INTERNAL_SEARCH)
    }
  }

  concatResult(data, external) {
    this.results = this.results.concat([...data].map((d) => ({...d, fromExternal: external})))
  }

  concatDivider(dividerName) {
    if(this.hasDividerTitle[dividerName]) {
      return
    }
    this.results.push({divider: true, dividerName})
    this.hasDividerTitle[dividerName] = true
  }

  async search() {
    if(!this.searchKeyword || this.searching) {
      return
    }
    this.searching = true
    this.resetResult()
    this.clear()
    const clients: any = await this.getClients({sales: true, name: this.searchKeyword})
    this.concatClientResult(clients)
    if(this.noMoreClient) {
      this.clearCompanies()
      const companies: any = await this.getCompanies({name: this.searchKeyword, page: 1})
      this.concatCompanyResult(companies)
    }
    this.blurSearchInput()
    this.searching = false
  }

  async onSelect(company) {
    if(!company.fromExternal) {
      this.onSelectClient(company)
      return
    }
    this.clear()
    await this.getClients({sales: true, bizNum: company.bizRegistrationNumber})
    if(this.clients) {
      // TODO: 사업자번호 같고 종사업자번호 다른 Client 처리
      const result = this.clients.find((client: any) => company.bizRegistrationNumber === client.bizRegistrationNumber)
      if(result) {
        this.onSelectClient(result)
        return
      }
    }
    await this.$emit('select-company', company)
    await this.onClickClose()
  }

  onSelectClient(value) {
    this.$emit('select-client', value)
    this.onClose()
  }

  selectDirectInput() {
    this.$emit('direct-input', this.searchKeyword)
    this.onClickClose()
  }

  onClickClose() {
    this.onClose()
  }

  async searchCompanies(name, page) {
    this.searching = true
    const companies: any = await this.getCompanies({name, page})
      .catch((error) => {
        const {status} = error.response
        if(status === 503) {
          return this.searchCompanies(name, page+1)
        }
        this.updateError({
          id: 'get-companies',
          message: `${this.ts('biz')} 목록을 불러오는데 ${this.ts('failed')}하였습니다.`,
        })
        this.$sentry.withScope((scope) => {
          scope.setExtra('data', {name, page})
          scope.setExtra('error', error)
          this.$sentry.captureException(new Error('Failed to search company.'))
        })
        return null
      })
      .finally(() => {
        this.searching = false
      })
    this.concatCompanyResult(companies)
  }

  async searchClients(name) {
    this.searching = true
    const clients: any = await this.getClients({sales: true, name: name})
      .catch((error) => {
        this.$sentry.withScope((scope) => {
          scope.setExtra('data', {
            name: name
          })
          scope.setExtra('error', error)
          this.$sentry.captureException(new Error('Failed to search client.'))
        })
        return null
      })
      .finally(() => {
        this.searching = false
      })
    this.concatClientResult(clients)
  }

  searchMoreCompanies() {
    if(this.noMoreCompany) {
      return
    }
    this.searchCompanies(this.searchKeyword, this.nextPage || 1)
  }

  searchMoreClients() {
    if(this.noMoreClient) {
      return
    }
    this.searchClients(this.searchKeyword)
  }

  onInfiniteScroll() {
    if(this.searchKeyword) {
      if(this.noMoreClient) {
        this.searchMoreCompanies()
      } else {
        this.searchMoreClients()
      }
    } else {
      this.loadClients()
    }
  }

  onHandleDelete() {
    if(!this.searchKeyword) {
      this.loadClients()
      this.clearCompanies()
    }
  }
}

